/**
 * Created by akrio on 2018/3/26.
 */
import BMF from "browser-md5-file";
import ImageCompressor from "image-compressor.js";
import "./filter";
import EXIF from "exif-js";
import { initValidate } from "../utils/errors";
/**
 * 图片md5加密
 * @param image 图片文件
 * @returns {Promise}
 */
export function md5({ image }) {
  return new Promise((resolve, reject) => {
    const bmf = new BMF();
    bmf.md5(
      image,
      (err, md5) => {
        if (err) {
          reject(err);
        } else {
          resolve(md5);
        }
      },
      (progress) => {}
    );
  });
}

/**
 * 图片压缩
 * @param image 需要压缩的图片
 */
/**
 * 图片压缩
 * @param image 需要压缩的图片
 * @param original 是否为原尺寸，即不进行任何压缩
 * @returns {Promise<Blob>}
 */
export async function compressor({ image, ins = false }) {
  const imageCompressor = new ImageCompressor();
  imageCompressor.crossOrigin = "Anonymous";
  let params;
  // 如果是ins账号限定宽度
  if (ins) {
    params = {
      quality: 1,
      minWidth: 320,
      maxWidth: 1080,
      mimeType: "image/jpeg",
    };
  } else {
    params = {
      quality: 0.6,
      minWidth: 50,
      minHeight: 50,
      maxHeight: 300,
      maxWidth: 300,
      mimeType: "image/jpeg",
    };
  }
  const result = await imageCompressor.compress(image, params);
  return result;
}

/**
 * 图片滤镜
 * @param image 图片
 * @param type 类型
 */
export function imgFilter({ image, type }) {
  // eslint-disable-next-line
  const fi = filterous.importImage(image).applyInstaFilter(type);
  return fi.canvas;
}

/**
 * 将页面加载完成处理成promise
 * @param image image对象
 * @param src 直接输入url地址
 * @param test 测试所需 强制失败
 */
export function imageLoad({ image, src, test = false }) {
  if (!image && !src) return;
  let img = image;
  if (src) {
    img = new Image();
    img.src = src;
  }
  const promise = new Promise((resolve, reject) => {
    img.onload = () => {
      if (test) {
        reject(
          initValidate({
            msg: "network error11",
          })
        );
      } else {
        resolve(img);
      }
    };
    img.onerror = () => {
      console.error("图片加载失败");
      reject(
        initValidate({
          msg: "network error",
        })
      );
    };
  });
  return promise;
}

/**
 * 获取图片的blob
 * @param image image对象
 */
export function imageBlob({ image }) {
  const promise = new Promise((resolve) => {
    image.toBlob(async (blob) => {
      resolve(blob);
    });
  });
  return promise;
}

/**
 * canvas 转blob
 * @param canvas 需要转换的canvas
 * @returns {Promise<any>}
 */
export function canvasBlob({ canvas }) {
  const promise = new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    });
  });
  return promise;
}

/**
 * 获取video  信息
 * @param video video元素
 * @returns {Promise<any>}
 */
export function getVideoDimensions({ video }) {
  return new Promise((resolve) => {
    video.addEventListener("loadeddata", () => {
      resolve({
        height: video.videoHeight, // 视频高度
        width: video.videoWidth, // 视频宽度
        ratio: video.videoWidth / video.videoHeight, // 视频比例
        duration: parseInt(video.duration), // 视频播放时长
      });
    });
  });
}

/**
 * 获取视频播放时长
 * @param url 视频对应url
 */
export function getVideoDuration({ url }) {
  const video = document.createElement("video");
  video.src = url;
  return new Promise((resolve) => {
    video.addEventListener("durationchange", () => {
      resolve(parseInt(video.duration));
    });
  });
}

/**
 * 获取图片的方向
 *
 * @export
 */
export async function getImageOrientation({ model }) {
  return new Promise((resolve) => {
    // 如果图片本身就有旋转则加一个旋转(查看通过js获取的宽高时候是否和<img>宽高相同)
    EXIF.getData(model.image, function () {
      var imageOrientation = EXIF.getTag(this, "Orientation");
      resolve(Number(imageOrientation));
    });
  });
}

/**
 * 获取初始化图片参数 最大最小比例，居中时的xy 坐标
 * @param model
 */
export async function getInitImgParams({ model }) {
  // 获取裁切框大小
  let cropWidth = 1;
  let cropHeight = 1;
  let imageWidth = 1;
  let imageHeight = 1;
  let minScale = 1;
  let maxScale = 1;
  let x = 0;
  let y = 0;
  // 是否旋转了宽高对调
  let exchange = model.rotate % 180 !== 0;
  // 如果图片本身就有旋转则加一个旋转(查看通过js获取的宽高时候是否和<img>宽高相同)
  const imageOrientation = await getImageOrientation({ model });
  if (imageOrientation > 4) {
    exchange = !exchange;
  }
  // 计算图片的宽高比例
  let imageRatio = model.image.width / model.image.height;
  // 如果图片本身旋转了
  if (imageOrientation > 4) {
    imageRatio = model.image.height / model.image.width;
  }
  if (imageRatio > 1) {
    // 宽大于高则说明宽是1
    imageHeight = 1 / imageRatio;
  } else {
    imageWidth = imageRatio;
  }
  if (model.lock) {
    // 宽大于高则说明高需要调整
    if (model.percentage > 1) {
      cropHeight = 1 / model.percentage;
    } else {
      cropWidth = model.percentage;
    }
  }
  // 说明旋转比例发生改变 宽高对调
  if (exchange) {
    const temp = imageWidth;
    imageWidth = imageHeight;
    imageHeight = temp;
  }
  /**
   * 图片的长边为1 极限宽高比0.8-1.91
   * 此处重新计算最大最小缩放防止裁切比例达不到要求
   * lock模式因为比例已固定所以只需保证图片能铺满即可
   * 非lock模式由于比例不确定所以和lock不共用一套计算逻辑
   */
  if (model.lock) {
    // 宽高打到标准所需放大的最小比例
    let heightMagnify = 1;
    let widthMagnify = 1;
    if (imageWidth < cropWidth) {
      widthMagnify = cropWidth / imageWidth;
    }
    if (imageHeight < cropHeight) {
      heightMagnify = cropHeight / imageHeight;
    }
    // 然后取最大值进行缩放
    const magnify = Math.max(heightMagnify, widthMagnify);
    minScale = Math.round(magnify * 1000) / 1000;
  } else {
    const cropImageRatio = imageWidth / imageHeight;
    if (cropImageRatio < 0.8) {
      minScale = 0.8 / imageWidth;
      console.log("进入非lock 但是发现过高 minScale", minScale);
    } else if (cropImageRatio > 1.91) {
      minScale = 1 / 1.91 / imageHeight;
      console.log("进入非lock 但是发现过宽 minScale", minScale);
    }
  }
  maxScale = minScale * 3;
  // 防止原缩放比例在范围之外
  let scale = model.scale;
  if (scale < minScale) {
    scale = minScale;
  }
  if (scale > maxScale) {
    scale = maxScale;
  }
  // 根据x,y坐标和缩放比例计算裁切出图片的大小
  let percentage;
  if (model.lock) {
    // 锁定状态则直接返回指定的比例
    percentage = model.percentage;
  } else {
    // 非锁定状态 长边永远=1 短边为比例*缩放比
    const imgW = imageWidth * scale;
    const imgH = imageHeight * scale;
    if (imageWidth > imageHeight) {
      // 宽永远为1 高根据比例
      percentage = 1 / imgH;
    } else {
      percentage = imgW;
    }
  }
  // 计算x,y 居中位置
  x = (1 - imageWidth * scale) / 2;
  y = (1 - imageHeight * scale) / 2;
  return {
    x,
    y,
    minScale,
    maxScale,
    image: model.image,
    percentage: percentage,
  };
}

/**
 * 导出图片
 */
export async function exportImg({ model }) {
  let image = new Image();
  image.crossOrigin = "anonymous";
  image.src = `${model.url}?t=${new Date().getTime()}`;
  await imageLoad({ image });
  // 初始化裁切所用canvas
  const rotateCanvas = document.createElement("canvas");
  const rotateCtx = rotateCanvas.getContext("2d");
  // 获取图片原始宽高
  const canvasW = image.width;
  const canvasH = image.height;
  // 图片进行翻转
  if (model.rotate === 0) {
    rotateCanvas.width = canvasW;
    rotateCanvas.height = canvasH;
    rotateCtx.drawImage(image, 0, 0, canvasW, canvasH);
  } else if (model.rotate === 90) {
    rotateCanvas.width = canvasH;
    rotateCanvas.height = canvasW;
    rotateCtx.rotate((90 * Math.PI) / 180);
    rotateCtx.drawImage(image, 0, -canvasH, canvasW, canvasH);
  } else if (model.rotate === 180) {
    rotateCanvas.width = canvasW;
    rotateCanvas.height = canvasH;
    rotateCtx.rotate((180 * Math.PI) / 180);
    rotateCtx.drawImage(image, -canvasW, -canvasH, canvasW, canvasH);
  } else if (model.rotate === 270) {
    rotateCanvas.width = canvasH;
    rotateCanvas.height = canvasW;
    rotateCtx.rotate((270 * Math.PI) / 180);
    rotateCtx.drawImage(image, -canvasW, 0, canvasW, canvasH);
  }
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  // 获取原始图片比例
  const imageRatio = rotateCanvas.width / rotateCanvas.height;
  let baseSize = 1;
  let cropX;
  let cropY;
  let cropWidth;
  let cropHeight;
  // 计算基准宽度
  if (imageRatio < 1) {
    baseSize = rotateCanvas.height;
  } else {
    baseSize = rotateCanvas.width;
  }
  cropWidth = baseSize / model.scale;
  cropHeight = baseSize / model.scale;
  cropX = (model.x * baseSize) / model.scale;
  cropY = (model.y * baseSize) / model.scale;
  // 计算图片是否存在留白，如果留白则相应减少裁切宽度
  if (rotateCanvas.width * model.scale <= baseSize) {
    cropWidth = rotateCanvas.width;
    cropX = 0;
  }
  if (rotateCanvas.height * model.scale <= baseSize) {
    cropHeight = rotateCanvas.height;
    cropY = 0;
  }
  canvas.width = cropWidth;
  canvas.height = cropHeight;
  // 如果图片进行翻转则宽高对调
  ctx.drawImage(
    rotateCanvas,
    -cropX,
    -cropY,
    cropWidth,
    cropHeight,
    0,
    0,
    cropWidth,
    cropHeight
  );
  // 添加滤镜
  let currentCropImage = new Image();
  currentCropImage.src = canvas.toDataURL("image/jpeg");
  const resultImg = imgFilter({ image: currentCropImage, type: model.filter });
  return resultImg.toDataURL("image/jpeg");
}

/**
 * 获取裁切的比例
 * @param model
 */
export function getImageCropPercentage({ model }) {
  const image = model.image;
  // 获取原始图片比例
  const imageRatio = image.width / image.height;
  let baseSize = 1;
  let cropWidth;
  let cropHeight;
  // 计算基准宽度
  if (imageRatio < 1) {
    baseSize = image.height;
  } else {
    baseSize = image.width;
  }
  cropWidth = baseSize / model.scale;
  cropHeight = baseSize / model.scale;
  // 计算图片是否存在留白，如果留白则相应减少裁切宽度
  if (image.width * model.scale <= baseSize) {
    cropWidth = image.width;
  }
  if (image.height * model.scale <= baseSize) {
    cropHeight = image.height;
  }
  let ratio = cropWidth / cropHeight;
  // 如果發生旋轉則寬高對調
  if (model.rotate % 180 !== 0) {
    ratio = 1 / ratio;
  }
  return ratio;
}
